"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _layers = require("../../layers");

var MenuDivider =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(MenuDivider, _React$PureComponent);

  function MenuDivider() {
    (0, _classCallCheck2.default)(this, MenuDivider);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MenuDivider).apply(this, arguments));
  }

  (0, _createClass2.default)(MenuDivider, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_layers.Pane, {
        borderBottom: true
      });
    }
  }]);
  return MenuDivider;
}(_react.default.PureComponent);

exports.default = MenuDivider;
MenuDivider.displayName = "MenuDivider";
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tZW51L3NyYy9NZW51RGl2aWRlci5qcyJdLCJuYW1lcyI6WyJNZW51RGl2aWRlciIsIlJlYWN0IiwiUHVyZUNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztJQUVxQkEsVzs7Ozs7Ozs7Ozs7OzZCQUNWO0FBQ1AsYUFBTyw2QkFBQyxZQUFEO0FBQU0sUUFBQSxZQUFZO0FBQWxCLFFBQVA7QUFDRDs7O0VBSHNDQyxlQUFNQyxhOzs7QUFBMUJGLFciLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBQYW5lIH0gZnJvbSAnLi4vLi4vbGF5ZXJzJ1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBNZW51RGl2aWRlciBleHRlbmRzIFJlYWN0LlB1cmVDb21wb25lbnQge1xuICByZW5kZXIoKSB7XG4gICAgcmV0dXJuIDxQYW5lIGJvcmRlckJvdHRvbSAvPlxuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/menu/src/MenuDivider.js
// module id = 168
// module chunks = 0